<template>
  <div style="height: 100%; background-color: #fff">
    <div style="border-bottom: 1px solid #e5e5e5"></div>
    <div class="headerTitle">
      <div class="headerBox">
        <div class="fs22 ftc22 ftb">招标管理系统</div>
        <!-- <div class="fs22 ftc22 ftb">重庆交运集团废旧物资处置平台</div> -->
        <div class="isLogin">
          <el-dropdown @command="command">
            <span class="el-dropdown-link">
              <div class="ftc66" style="width: 100%; display: flex;cursor: pointer;">
                <div class="loginName">
                  <img
                    src="@/image/login.png"
                    alt=""
                    style="width: 14px; height: 14px; display: block"
                  />
                </div>
                {{ backstageUser.userName }}
                <div class="loginName">
                  <img
                    src="@/image/jt.png"
                    alt=""
                    style="width: 7px; height: 5px; display: block"
                  />
                </div>
              </div>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="1">废旧物资处置平台</el-dropdown-item>
              <el-dropdown-item :command="3">修改密码</el-dropdown-item>
              <el-dropdown-item :command="2">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>

    <div class="mainBox">
      <div class="leftMain">
        <menuItem> </menuItem>
      </div>
      <div class="rightMain">
        <!-- 面包屑 -->
        <div class="breadcrumblist">
          <img src="@/image/1.png" alt="" />
          <el-breadcrumb separator="/">
            <el-breadcrumb-item
              :to="{ path: item.path }"
              v-for="(item, index) in currentMate"
              :key="index"
              >{{ item.name }}</el-breadcrumb-item
            >
          </el-breadcrumb>
        </div>
        <!-- 路由出口 -->
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import menuItem from "./menuItem";
import {loginOut} from "@/api/login"
export default {
  components: {
    menuItem,
  },
  data() {
    return {
      backstageUser: {},
      sessionId: '',
    };
  },
  mounted() {
    this.sessionId = sessionStorage.getItem("sessionId");
    this.backstageUser = JSON.parse(sessionStorage.getItem("backstageUser"));
  },
  computed: {
    currentMate() {
      var list = this.$route.matched.map((res) => {
        return {
          name: res.meta.name,
          path: res.path,
        };
      });
      return list;
    },
  },
  methods: {
    command(e) {
      if (e == 2) {
        // sessionStorage.clear();
        // this.$router.push({
        //   path: "/home/homepage",
        // });
        loginOut({sessionId: this.sessionId}).then(res=>{
          if(res.data.code==1) {
            sessionStorage.clear();
            this.$router.push({
              path: "/home/homepage",
            });
            this.$message.success(res.data.msg)
          }
        })
      }

      if (e == 1) {
        this.$router.push({
          path: "/home/homepage",
        });
      }
      if (e == 3) {
        this.$router.push({
          path: "/servicecenter/modifypwd",
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.loginName {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
}

.isLogin {
  display: flex;
  height: 40px;
  line-height: 40px;
  justify-content: flex-end;
  text-align: center;
  // padding-right: 350px;

  .regBox {
    border-right: 1px solid #e5e5e5;

    img {
      width: 15px;
      height: 15px;
    }
  }
}

.headerTitle {
  box-shadow: 0px 5px 10px 0px rgba(197, 197, 197, 0.2);
  background-color: #fff;
}

.headerBox {
  height: 100px;
  line-height: 100px;
  padding: 0 37px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.mainBox {
  display: flex;
  width: 100%;
  height: 100%;
  background-color: #f8f8f8;

  .leftMain {
    width: 250px;
    height: 100%;
  }

  .rightMain {
    flex: 1;
    box-sizing: border-box;
    padding: 20px;
    width: 100%;
    height: 100%;
    // background: red;
  }
}
.breadcrumblist {
  padding: 0 0 20px;
  display: flex;
  align-items: center;
  img {
    display: block;
    width: 12px;
    height: 11px;
    padding-right: 6px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/servicecenter/index.vue